var _jsxFileName = "/codebuild/output/src2760838910/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/auth/ResetPassword/helpers/Container.tsx";
import React, { useMemo } from 'react';
import { Stack, useThemeName } from '@adc/parallax-component-library';
import { useTheme } from '@adc/parallax-component-library';
import { useMediaQuery } from 'Hooks';
import { AppLogo } from 'Components/utility';
const MEDIA_QUERY = {
  maxWidth: 440
};
const Container = ({
  children
}) => {
  const [isMobileBrowser] = useMediaQuery(MEDIA_QUERY);
  const theme = useTheme();
  const themeName = useThemeName();
  // @ts-expect-error Typescript complains on `.val` usage
  const color = theme['surface.container'].val;
  const additionalProps = useMemo(() => isMobileBrowser ? {
    padding: 16
  } : {
    borderRadius: 32,
    padding: 80,
    paddingTop: 48,
    shadow: '$1',
    maxWidth: 560
  }, [isMobileBrowser]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isMobileBrowser && /*#__PURE__*/React.createElement("meta", {
    name: "theme-color",
    media: `(prefers-color-scheme: ${themeName})`,
    content: color,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Stack, {
    flexDirection: "column",
    backgroundColor: isMobileBrowser ? '$surface.container' : '$surface.background',
    alignItems: "center",
    style: [{
      minHeight: window.innerHeight,
      height: '100vh'
    }],
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(AppLogo, {
    isMobileBrowser: isMobileBrowser,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Stack, Object.assign({}, additionalProps, {
    backgroundColor: "$surface.container",
    gap: "$8",
    width: "100%",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 9
    }
  }), children)));
};
export { Container };